import dayjs from 'dayjs'
import { jwtDecode } from 'jwt-decode'

import { ISession, ISessionRefreshToken } from 'shared/models/Auth'

export const getIsRefreshTokenExpired = (refreshToken: ISession['refresh']): boolean => {
  const decodedRefreshToken = jwtDecode<ISessionRefreshToken>(refreshToken)

  const isRefreshTokenExpired = dayjs(decodedRefreshToken.exp * 1000).isBefore(dayjs())

  return isRefreshTokenExpired
}
